export default function TbPw({data}) {
    let lastReading = data.data;

    return (
      <>
        <div className="card card-table mb-4 rounded-1 shadow-sm">
          <div className="card-header py-2">
            <h4 className="my-0">Polished Water</h4>
          </div>
          <div className="card-body nopadding">
          <table className="table table-sm my-0 tbl">
              <thead>
                <tr>
                  <th scope="col">Silo</th>
                  <th scope="col">Level</th>
                </tr>
              </thead>
              <tbody>
              <tr>
                  <td>PW 1</td>
                  <td>{lastReading.pw_pw1_level}%</td>
                </tr>
                <tr>
                  <td>PW 2</td>
                  <td>{lastReading.pw_pw2_level}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    )
}